export default "https://legacy.eskolare-development.com/images/icon-512x512.png";